import Promise from 'bluebird'

import * as types from './mutation-types'

export const loadAuthData = ({ commit }) => {
  console.log('load auth data!')
  console.log(types)
  let x = 2
  if (x === 2) {
    return Promise.reject(new Error('Authentication data not found.'))
  } else {

  }
}

export const login = ({ dispatch }, username, password, license) => {
  console.log('login!')
  console.log(username, password)
}



// WEBPACK FOOTER //
// ./src/store/actions.js